<template>
  <textarea ref="redactor" :name="name" :placeholder="placeholder" :value="value" />
</template>
<script>
import Vue from 'vue'
import Redactor from '@/assets/redactor/redactor.min.js'
// eslint-disable-next-line no-unused-vars
import * as fullScreen from '@/assets/redactor/plugins/fullscreen/fullscreen.min.js'
// eslint-disable-next-line no-unused-vars
import * as alignment from '@/assets/redactor/plugins/alignment/alignment.min.js'
// eslint-disable-next-line no-unused-vars
import * as imagemgr from '@/assets/redactor/plugins/imagemanager/imagemanager.min.js'
// eslint-disable-next-line no-unused-vars
import * as table from '@/assets/redactor/plugins/table/table.min.js'
// eslint-disable-next-line no-unused-vars
import * as li from '@/assets/redactor/plugins/fontcolor/fontcolor.min.js'
// eslint-disable-next-line no-unused-vars
import * as mmizo from '@/assets/redactor/plugins/mizo/makkati_mizo.js'

import * as urlConstant from '@/constants/url'
import editorApi from '@/api/editorApi'

require('@/assets/redactor/redactor.min.css')
export default {
  props: {
    value: {
      default: '',
      type: String
    },
    placeholder: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    }

  },

  data () {
    return {
      redactor: false,
      config: {
        minHeight: '200px',
        toolbarFixed: true,
        imageResizable: true,
        imagePosition: true,
        toolbarFixedTopOffset: 60,
        plugins: [
          'alignment',
          'imagemanager',
          'table',
          'fontcolor',
          'fullscreen',
          'makkati_mizo'
        ],
        imageUpload: async function (formData, filez, event, upload) {
          console.log('images', filez)
          console.log('formData', formData)
          const data = { files: [] }
          filez.forEach(function (k) {
            data.files.push(k)
          })
          const response = await editorApi.uploadImages(data)
          console.log(response.data)
          upload.complete(response.data)
        },
        imageManagerJson: urlConstant.EDITOR_IMG_BROWSE_URL
      }
    }
  },
  watch: {
    value: function (newValue, oldValue) {
      if (!this.redactor.editor.isFocus()) {
        this.redactor.source.setCode(newValue)
      }
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    init () {
      console.log('init redactor')
      var me = this
      var callbacks = {
        changed: function (html) {
          me.handleInput(html)
          return html
        }
      }

      // extend config
      if (typeof this.config.callbacks === 'undefined') {
        Vue.set(this.config, 'callbacks', callbacks)
      } else {
        this.config.callbacks.changed = callbacks.changed
      }

      // call Redactor
      var app = Redactor(this.$refs.redactor, this.config)

      // set instance
      this.redactor = app
      this.$parent.redactor = app
    },
    destroy () {
      // Call destroy on redactor to cleanup event handlers
      Redactor(this.$refs.redactor, 'destroy')

      // unset instance for garbage collection
      this.redactor = null
      this.$parent.redactor = null
    },
    handleInput (val) {
      this.$emit('input', val)
    }

  }

}
</script>
